//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Object.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["smooth_curve_string"],"CreateSmoothCurveStringBuilder",{R_:{builder:"Features.SmoothCurveStringBuilder"}},1,0],[["polyline"],"CreatePolylineBuilder",{R_:{builder:"Features.PolylineBuilder"}},1,0],[["spine_curve"],"CreateSpineCurveBuilder",{R_:{builder:"Features.SpineCurveBuilder"}},1,0],[["isocline_curve"],"CreateIsoclineCurveBuilder",{R_:{builder:"Features.IsoclineCurveBuilder"}},1,0],[["blend_curve_on_surface"],"CreateBlendCurveOnSurfaceBuilder",{R_:{builder:"Features.BlendCurveOnSurfaceBuilder"}},1,0]],[["DrawShapeCollection","Features.DrawShapes.DrawShapeCollection",0]]];
SPLM.Features.FreeformCurveCollection = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.FreeformCurveCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;